import { Courier } from '../../interfaces/Courier'
import { GET_COURIERS_EXITO, GET_COURIERS } from '../types/courierActionsTypes'

export type CourierAction = CouriersAction | CouriersActionAsync

// Esto va a REDUX
export interface CouriersAction {
  type: typeof GET_COURIERS_EXITO
  couriers: Courier[] | undefined
  error: string | undefined
}

export const getCouriersAction = (
  couriers?: Courier[],
  error?: string
): CouriersAction => {
  return {
    type: GET_COURIERS_EXITO,
    couriers,
    error
  }
}

// Esto va a SAGA
export interface CouriersActionAsync {
  type: typeof GET_COURIERS
}

export const getCouriersActionAsync = (): CouriersActionAsync => {
  return {
    type: GET_COURIERS
  }
}
